/**
 * Фильтр задач.
 * @param {?string} authorId
 * @param {?string} performerId
 * @param {?string} patientId
 * @param {?string} roleName
 * @param {Array} createPeriod
 * @param {Array} deadlinePeriod
 * @constructor
 */
export default function TaskFilterRequest(
  authorId = null,
  performerId = null,
  patientId = null,
  roleName = null,
  createPeriod = [],
  deadlinePeriod = [],
) {
  this.authorId = authorId;
  this.performerId = performerId;
  this.patientId = patientId;
  this.roleName = roleName;
  this.createPeriod = createPeriod;
  this.deadlinePeriod = deadlinePeriod;

  /**
   * @description Пустой ли фильтр
   * @returns {boolean}
   */
  this.isEmpty = () => JSON.stringify(this) === JSON.stringify(new TaskFilterRequest());
}
